<template>
    <div>
        <div class="page_content">
            <div class="back_icon"
                 @click="goBack"></div>
            <div class="page_top">
                <div class="page_title">书法班级圈</div>
                <!-- <div class="activity_time">已进行 {{pageData.now_day_number+"/"+pageData.max_day_number}} 天</div> -->
                <div class="words_list clearfix">
                    <div @click="playVideo(word.video_url)"
                         :class="['word_item',{'single_width':word.content.length==1},{'double_width':word.content.length>1&&word.content.length<5},{'triple_width':word.content.length>4&&word.content.length<9},{'quadra_width':word.content.length>8}]"
                         v-for="(word,i) in word_lists"
                         :key="word.content">{{ word.content }}</div>
                </div>
                <div class="word_tips">请同学们练习以上内容，点击文字可播放视频。</div>
            </div>
            <div class="page_rank">
                <router-link :to="'/activity/sf_clock/rank/'+unit_class_id">
                    <div class="rank_content">
                        <div class="rank_top">
                            <div class="rank_title">班级排行榜</div>
                            <div class="rank_no">查看全部<img class="more_icon"
                                     src="./img/img_icon_03.png"></div>
                        </div>
                        <div class="rank_user">
                            <div v-for="user in pageData.rank_data"
                                 class="user_item">
                                <div class="user_head">
                                    <div class="portrait">
                                        <img v-if="user.length"
                                             class="portrait_img"
                                             :src="user[0].portrait"
                                             alt="">
                                        <div v-else
                                             class="portrait_img no_user">空</div>
                                    </div>
                                    <div :class="['more_portrait',{'single':user.length==2},{'double':user.length>2}]"></div>
                                </div>
                                <div class="user_name"
                                     v-if="user.length">
                                    {{user[0].name}}{{ user.length==1 ? "" : "等"+user.length+"人" }}
                                </div>
                            </div>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="page_date">
                <div @click="chooseDay(day)"
                     :class="['date_item',{'disabled':day.status==2},{'recent':day.clock_day==recentDay},{'selected':day.clock_day==selectDay.clock_day}]"
                     v-for="day in pageData.day_data">
                    <div class="date_day">{{ day.day }}</div>
                    <div class="date_status"><span class="right_icon"
                              v-if="day.status==1"></span>{{ day.status == 1 ? "已打" : (day.status == 0 && day.clock_day != recentDay) ? "补卡" : day.month+"月" }}</div>
                </div>
            </div>
            <div class="work_list"
                 v-if="work_lists.length">
                <div class="work_item"
                     v-for="(work,i) in work_lists">
                    <div class="item_tops">
                        <img class="stu_head"
                             :src="work.portrait"
                             alt="">
                        <div class="work_info">
                            <div class="stu_name">{{ work.stu_name }}</div>
                            <div class="work_time">发布于{{ work.add_time }}</div>
                        </div>
                        <img @click="deleteWork(work.id,i)"
                             v-if="work.is_me"
                             class="delete_icon"
                             src="./img/img_icon_09.png"
                             alt="">
                    </div>
                    <div class="img_list clearfix">
                        <img class="photo_img"
                             @click="previewImg(work.img,index)"
                             v-for="(img,index) in work.img"
                             :key="index"
                             :preview="1"
                             :src="fileRoot+'/'+img">
                    </div>
                </div>
                <loadmore :noMore="noMore"></loadmore>
            </div>
            <div v-else
                 class="no_work">
                <no-resouse text="暂无人上传"></no-resouse>
            </div>
            <div class="fixed_bottom">
                <button class="bottom_btn to_mine"
                        @click="share">分享活动</button>
                <button class="bottom_btn to_clock"
                        @click="jumpUrl('/activity/sf_clock/rank/'+unit_class_id)">查看班级排行榜</button>
            </div>
            <videoPlayer v-if="!inApp"
                         ref="videoPlayer"
                         @closePlayer="closePlayer"
                         v-show="videoPlay"
                         :video_url="video_url"></videoPlayer>
        </div>

    </div>
</template>

<script>
import loadingS from 'SRC/components/base/loadingS.vue';
import videoPlayer from 'SRC/components/base/videoPlayer.vue';  // 视频播放弹窗
import noResouse from "SRC/components/noResouse.vue"
import loadmore from "SRC/components/loadmore.vue"

export default {
    components: { loadingS, videoPlayer, noResouse, loadmore },
    data () {
        return {
            unit_class_id: this.$route.params.unit_class_id,
            loading: true,
            page_from: this.$route.query.page_from || 0, //1-wap站登录
            recentDay: 0,
            page: 1,
            pageData: {},
            word_lists: [],
            work_lists: [],
            videoPlay: false,
            video_url: "",
            selectDay: {},
            fileRoot: FILE_VIEW_URLROOT,
            moreLoading: true,
            noMore: false,
        }
    },
    created () {
        document.title = '爱尚书法';
        this.getData();
        window.addEventListener('scroll', this.loadMore, false);
    },
    methods: {
        previewImg (imgList, index) {
            let imgs = []
            imgList.forEach(e => {
                imgs.push(this.fileRoot + '/' + e)
            })
            if (this.inApp) {
                this.appFunction("ys_preview_imgs", `${imgs.join("-")},0`);
            } else {
                this.$nextTick(() => {
                    this.$imagePreview({
                        images: imgs,
                        index: index,
                        defaultOpt: {
                            bgOpacity: 1,
                            showHideOpacity: true,
                            errorMsg: '<div class="pswp__error-msg">图片加载失败</div>',
                            tapToClose: true, // 点击上层图层关闭预览
                        }
                    });
                })
            }
        },
        goBack () {
            this.$router.go(-1);
        },
        playVideo (url) {
            if (!url) {
                return
            }
            if (this.inApp) {
                this.play(url)
            } else {
                this.video_url = url;
                this.videoPlay = true;
                this.$nextTick(() => {
                    this.$refs.videoPlayer.play();
                })
            }
        },
        closePlayer () {
            this.videoPlay = false;
        },
        chooseDay (day, index) {
            if (day.status == 2) return
            this.selectDay = day;
            this.$http.post(API_URL_HD_API + '/sf_clock/word/', { "clock_day": day.clock_day, unit_class_id: this.unit_class_id }).then((data) => {
                data = data.data;
                if (data.response === 'ok') {
                    this.word_lists = data.data;
                } else {
                    layer.tips(data.message);
                }
                if (this.loading) {
                    this.loading = false;
                    this.$nextTick(() => {
                        setTimeout(() => {
                            let dw = document.querySelector(".recent").offsetWidth;
                            let m = dw * 98 / 90;
                            document.querySelector(".page_date").scrollLeft = m * index - (document.body.clientWidth - dw) / 2 + dw * 8 / 90;
                        }, 10)
                    })

                }

            })
            this.page = 1;
            this.getClock();
        },
        jumpUrl (url) {
            this.$router.push(url);
        },
        deleteWork (id, i) {
            let _this = this;
            layer.open({
                title: '删除确认',
                content: `确定要删除此上传记录吗？删除后无法恢复`,
                btn: ['确认', '取消'],
                yes: function (index) {
                    _this.$http.post(API_URL_HD_API + '/sf_clock/delete_clock/', {
                        clock_id: id
                    }).then((res) => {
                        res = res.data;
                        if (res.response === 'ok') {
                            _this.work_lists.splice(i, 1);
                            for (let i = 0; i < _this.pageData.day_data.length; i++) {
                                if (_this.pageData.day_data[i].clock_day == _this.selectDay.clock_day) {
                                    _this.pageData.day_data[i].status = 0;
                                    break;
                                }
                            }
                            layer.tips("上传记录已删除");
                        } else {
                            layer.tips(res.message);
                        }
                    })
                    layer.close(index);
                }
            })

        },
        getData () {
            this.$http.post(API_URL_HD_API + '/sf_clock/tea/index/', { unit_class_id: this.unit_class_id }).then((res) => {
                res = res.data;
                if (res.response === 'ok') {
                    this.pageData = res.data;
                    if (res.data.open_clock) {
                        this.recentDay = this.pageData.first_day;
                        this.pageData.rank_data.unshift(this.pageData.rank_data[1]);
                        this.pageData.rank_data.splice(2, 1);
                        let index = 0;
                        for (let i = 0; i < this.pageData.day_data.length; i++) {
                            if (this.pageData.day_data[i].clock_day == this.pageData.first_day) {
                                index = i;
                                this.chooseDay(this.pageData.day_data[i], index);
                                break;
                            }
                        }
                    } else {
                        this.loading = false;
                    }
                } else {
                    layer.tips(res.message);
                }
            })
        },

        getClock () {
            this.$http.post(API_URL_HD_API + '/sf_clock/get_clock_by_data/', {
                page_no: this.page,
                data: this.selectDay.clock_day,
                unit_class_id: this.unit_class_id
            }).then((res) => {
                res = res.data;
                if (res.response === 'ok') {
                    if (this.page == 1) this.work_lists = [];
                    this.work_lists = this.work_lists.concat(res.data);
                    this.page++;
                    this.moreLoading = false;
                    if (res.data.length < 10) {
                        this.noMore = true;
                    }
                } else {
                    layer.tips(res.message);
                }
            })
        },
        loadMore () {
            if (!this.moreLoading && !this.loading && !this.noMore) {
                let that = this;
                this.loadMoreTimer && clearTimeout(this.loadMoreTimer);
                this.loadMoreTimer = setTimeout(() => {
                    let docHeight = document.body.scrollHeight || document.documentElement.scrollHeight;
                    let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
                    let winHeight = window.screen.availHeight;
                    if (winHeight + scrollTop >= docHeight - 50) {
                        that.moreLoading = true;
                        that.getClock();
                    }
                }, 500)
            }
        },
        share () {
            let that = this
            var url = WAP_URL + '/qr/com_special?hd_type=5'
            if (this.inApp) {
                this.appFunction("ys_share", `书法班级圈,点击参加书法班级圈,${url},11,0,0,0,书法打卡活动分享`)
            } else {
                this.$http.post(API_URL_SORT_API + '/create_sort/', {
                    url: url,
                    sort_type: 2
                }).then((res) => {
                    if (res.data.response === 'ok') {
                        let short_url = res.data.data.short_url
                        let coptText = `书法班级圈，点击链接即可参加书法班级圈,链接：${short_url}`;
                        that.copyVisible = true;
                        layer.alert('在输入框中进行粘贴后，点击发送即可！', 'tea', function (index) {
                            layer.close(index)
                            that.copyText(coptText);
                        }, '分享链接复制成功')
                    }
                })

            }
        },
        copyText (text) {
            const input = document.createElement('input');
            input.setAttribute('readonly', 'readonly');
            input.setAttribute('value', text);
            document.body.appendChild(input);
            input.setSelectionRange(0, 9999);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        },
        /**获取分享短链地址 */
        getShortUrl (url) {
            this.$http.post(API_URL_SORT_API + '/create_sort/', {
                url: url,
                sort_type: 2
            }).then((res) => {
                if (res.data.response === 'ok') {
                    return res.data.data.short_url
                }
            })
        },
    },
    destroyed () {
        clearTimeout(this.loadMoreTimer);
        window.removeEventListener('scroll', this.loadMore, false);
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.back_icon {
    height: 96px / $ppr;
    width: 84px / $ppr;
    background-size: 21px / $ppr 35px / $ppr;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url("./img/img_icon_01.png");
}
.page_content {
    max-width: 720px / $ppr;
    background: #fff;
    padding-bottom: 128px / $ppr;
    .header_line {
        height: 96px / $ppr;
    }
    .page_top {
        padding-left: 32px / $ppr;
        .page_title {
            font-size: 38px / $ppr;
            font-weight: bold;
            padding-top: 2px / $ppr;
            line-height: 86px / $ppr;
        }
        .activity_time {
            width: 170px / $ppr;
            text-align: center;
            height: 40px / $ppr;
            line-height: 40px / $ppr;
            font-size: 20px / $ppr;
            border-radius: 10px / $ppr;
            background-color: #f0fcf4;
            margin-bottom: 32px / $ppr;
        }
        .words_list {
            .word_item {
                height: 90px / $ppr;
                margin: 0 24px / $ppr 24px / $ppr 0;
                text-align: center;
                line-height: 88px / $ppr;
                font-size: 48px / $ppr;
                float: left;
                background-color: #f8fefa;
                border: 3px / $ppr solid #5dc47c;
                border-radius: 15px / $ppr;
                box-sizing: border-box;
                &.single_width {
                    width: 90px / $ppr;
                    background-size: 100% 100%;
                    background-image: url("./img/img_icon_12.png");
                }
                &.double_width {
                    width: 204px / $ppr;
                }
                &.triple_width {
                    width: 318px / $ppr;
                }
                &.quadra_width {
                    width: 432px / $ppr;
                }
            }
        }
        .word_tips {
            font-size: 28px / $ppr;
            color: #999;
            line-height: 40px / $ppr;
            margin-bottom: 24px / $ppr;
        }
    }
    .page_rank {
        padding: 0 32px / $ppr;
        position: relative;
        &::after {
            content: "";
            display: block;
            position: absolute;
            width: 100%;
            height: 22px / $ppr;
            left: 0;
            bottom: 0;
            background-size: 100% 100%;
            background-image: url("./img/img_icon_13.png");
        }
        .rank_content {
            background-color: #f2f6f7;
            border-radius: 20px / $ppr 20px / $ppr 0 0;
            color: #333;
            .rank_top {
                padding: 0 28px / $ppr;
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 66px / $ppr;
                .rank_title {
                    font-size: 28px / $ppr;
                }
                .rank_no {
                    font-size: 24px / $ppr;
                    color: #86919a;
                    .more_icon {
                        width: 11px / $ppr;
                        height: 18px / $ppr;
                        vertical-align: middle;
                        margin: -4px / $ppr 0 0 12px / $ppr;
                    }
                }
            }
            .rank_user {
                padding: 0 20px / $ppr;
                background-image: url("./img/img_icon_04.png");
                background-size: 616px / $ppr 93px / $ppr;
                background-position: center bottom;
                background-repeat: no-repeat;
                height: 266px / $ppr;
                display: flex;
                .user_item {
                    flex-grow: 1;
                    width: 0;
                    padding-top: 61px / $ppr;
                    &:first-child {
                        .user_head .portrait {
                            &::after {
                                background-image: url("./img/img_icon_05.png");
                            }
                            .portrait_img {
                                border: 5px / $ppr solid #b3c0c7;
                            }
                        }
                    }
                    &:nth-of-type(2) {
                        flex-grow: 0;
                        width: 256px / $ppr;
                        flex-shrink: 0;
                        padding-top: 11px / $ppr;
                        .user_head .portrait {
                            &::after {
                                background-image: url("./img/img_icon_06.png");
                            }
                            .portrait_img {
                                border: 5px / $ppr solid #f4bc42;
                            }
                        }
                    }
                    &:last-child {
                        .user_head .portrait {
                            &::after {
                                background-image: url("./img/img_icon_07.png");
                            }
                            .portrait_img {
                                border: 5px / $ppr solid #de9e65;
                            }
                        }
                    }
                    .user_head {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .portrait {
                            position: relative;
                            &::after {
                                content: "";
                                position: absolute;
                                width: 31px / $ppr;
                                height: 27px / $ppr;
                                background-size: 100% 100%;
                                top: -11px / $ppr;
                                left: 63px / $ppr;
                            }
                            .portrait_img {
                                width: 88px / $ppr;
                                height: 88px / $ppr;
                                border-radius: 50%;
                                &.no_user {
                                    text-align: center;
                                    line-height: 88px / $ppr;
                                    background-color: #e4e4e4;
                                    color: #86919a;
                                    font-size: 28px / $ppr;
                                }
                            }
                        }
                        .more_portrait {
                            background-size: 100% 100%;
                            height: 74px / $ppr;
                            margin-left: -10px / $ppr;
                            margin-top: -2px / $ppr;
                            &.single {
                                width: 27px / $ppr;
                                background-image: url("./img/img_icon_10.png");
                            }
                            &.double {
                                width: 44px / $ppr;
                                background-image: url("./img/img_icon_11.png");
                            }
                        }
                    }
                    .user_name {
                        font-size: 26px / $ppr;
                        line-height: 44px / $ppr;
                        text-align: center;
                    }
                }
            }
        }
    }
    .page_date {
        padding: 16px / $ppr 8px / $ppr;
        overflow-x: auto;
        display: flex;
        &::-webkit-scrollbar {
            display: none;
        }
        .date_item {
            width: 90px / $ppr;
            height: 90px / $ppr;
            border-radius: 45px / $ppr;
            text-align: center;
            margin-right: 8px / $ppr;
            flex-shrink: 0;
            &:last-child {
                margin-right: 0;
            }
            &.disabled {
                color: #bebfbf;
            }
            &.recent {
                color: #5dc47c;
                background-color: #e5fdec;
                .date_status .right_icon {
                    background-image: url("./img/img_icon_15.png");
                }
            }
            &.selected {
                color: #fff;
                background-color: #5dc47c;
                .date_status .right_icon {
                    background-image: url("./img/img_icon_08.png");
                }
            }
            .date_day {
                font-size: 32px / $ppr;
                line-height: 36px / $ppr;
                padding-top: 14px / $ppr;
            }
            .date_status {
                font-size: 20px / $ppr;
                line-height: 24px / $ppr;
                .right_icon {
                    display: inline-block;
                    width: 14px / $ppr;
                    height: 10px / $ppr;
                    background-image: url("./img/img_icon_14.png");
                    background-size: 100% 100%;
                    vertical-align: middle;
                    margin: -4px / $ppr 5px / $ppr 0 0;
                }
            }
        }
    }
    .work_list {
        .work_item {
            border-top: 1px / $ppr solid #d4d6d6;
            padding-bottom: 32px / $ppr;
            .item_tops {
                padding: 0 32px / $ppr;
                height: 144px / $ppr;
                display: flex;
                align-items: center;
                position: relative;
                .stu_head {
                    width: 72px / $ppr;
                    height: 72px / $ppr;
                    border-radius: 50%;
                    margin-right: 24px / $ppr;
                    flex-shrink: 0;
                }
                .work_info {
                    flex-grow: 1;
                    .stu_name {
                        font-size: 28px / $ppr;
                        line-height: 36px / $ppr;
                    }
                    .work_time {
                        font-size: 24px / $ppr;
                        color: #bebfbf;
                        line-height: 32px / $ppr;
                    }
                }
                .delete_icon {
                    position: absolute;
                    width: 29px / $ppr;
                    height: 30px / $ppr;
                    top: 60px / $ppr;
                    right: 32px / $ppr;
                }
            }
            .img_list {
                padding-left: 32px / $ppr;
                .photo_img {
                    display: block;
                    float: left;
                    margin-right: 29px / $ppr;
                    border-radius: 10px / $ppr;
                    width: 200px / $ppr;
                    height: 240px / $ppr;
                    object-fit: cover;
                }
            }
        }
    }
    .no_work {
        position: relative;
        height: 20rem;
    }
    .fixed_bottom {
        position: fixed;
        width: 100%;
        box-sizing: border-box;
        left: 0;
        bottom: 0;
        background-color: #fff;
        border-top: 1px / $ppr solid #eeeff0;
        padding: 18px / $ppr 28px / $ppr 22px / $ppr;
        display: flex;
        justify-content: space-between;
        .bottom_btn {
            width: 316px / $ppr;
            height: 88px / $ppr;
            box-sizing: border-box;
            border: 1px solid #edf0f1;
            font-size: 32px / $ppr;
            border-radius: 12px / $ppr;
            &.to_mine {
                background-color: #f3f6f7;
                color: #333;
            }
            &.to_clock {
                background-color: #5dc47c;
                color: #fff;
                &:disabled {
                    background-color: #fff;
                    color: #9c9d9e;
                }
                &:not(:disabled) {
                    border-color: #5dc47c;
                }
            }
        }
    }
}
</style>